import { HAIR } from './settings/hair';
import { FACE } from './settings/face';
import { SHIRT } from './settings/shirt';
import { PANTS } from './settings/pants';
import { OPTIONS } from '@/utils/common';
import SkinAvatar from './Options/SkinAvatar';
import ColorAvatar from './Options/ColorAvatar';
import DetailsAvatar from './Options/DetailsAvatar';
import AccessoriesAvatar from './Options/AccessoriesAvatar';
import IconFace from '@/assets/images/icons/icon-face.svg?component';
import IconWear from '@/assets/images/icons/icon-wear.svg?component';
import type { IAvatarOptions, ITabOption, ISetOption } from './types';
import IconFrame from '@/assets/images/icons/icon-frame.svg?component';
import IconPerson from '@/assets/images/icons/icon-person.svg?component';
import IconGlasses from '@/assets/images/icons/icon-glasses.svg?component';
import IconTrousers from '@/assets/images/icons/icon-trousers.svg?component';
import IconScissors from '@/assets/images/icons/icons-scissors.svg?component';

type ITabProps = {
  toggleColorPanel: (visible: boolean) => void;
  setFocus?: (focus: boolean) => void;
  options: IAvatarOptions;
  setOption: ISetOption;
};

export const GET_TAB_OPTIONS = ({
  toggleColorPanel,
  setOption,
  setFocus,
  options
}: ITabProps): ITabOption[] => {
  return [
    {
      label: 'Persoon',
      icon: <IconPerson />,
      value: OPTIONS.details,
      component: <DetailsAvatar options={options} setOption={setOption} setFocus={setFocus} />
    },
    {
      label: 'Kleur',
      icon: <IconFace />,
      value: OPTIONS.skinColor,
      component: (
        <SkinAvatar
          option={options[OPTIONS.skinColor]}
          name={OPTIONS.skinColor}
          setOption={setOption}
        />
      )
    },
    {
      label: 'Kapsel',
      value: OPTIONS.hair,
      icon: <IconScissors />,
      component: (
        <AccessoriesAvatar
          toggleColorPanel={toggleColorPanel}
          option={options[OPTIONS.elements]}
          setOption={setOption}
          name={OPTIONS.hair}
          keysItem="hair"
          label="Kapsel"
          list={HAIR}
        />
      )
    },
    {
      label: 'Gezicht',
      value: OPTIONS.face,
      icon: <IconGlasses />,
      component: (
        <AccessoriesAvatar
          toggleColorPanel={toggleColorPanel}
          option={options[OPTIONS.elements]}
          setOption={setOption}
          name={OPTIONS.face}
          keysItem="face"
          label="Gezicht"
          list={FACE}
        />
      )
    },
    {
      label: 'Boven',
      icon: <IconWear />,
      value: OPTIONS.shirt,
      component: (
        <AccessoriesAvatar
          toggleColorPanel={toggleColorPanel}
          option={options[OPTIONS.elements]}
          setOption={setOption}
          name={OPTIONS.shirt}
          keysItem="shirt"
          label="Boven"
          list={SHIRT}
        />
      )
    },
    {
      label: 'Onder',
      value: OPTIONS.pants,
      icon: <IconTrousers />,
      component: (
        <AccessoriesAvatar
          toggleColorPanel={toggleColorPanel}
          option={options[OPTIONS.elements]}
          setOption={setOption}
          name={OPTIONS.pants}
          keysItem="pants"
          label="Onder"
          list={PANTS}
        />
      )
    },
    {
      label: 'Kader',
      icon: <IconFrame />,
      value: OPTIONS.favoriteColor,
      component: (
        <ColorAvatar
          option={options[OPTIONS.favoriteColor]}
          name={OPTIONS.favoriteColor}
          setOption={setOption}
        />
      )
    }
  ];
};
